import $ from 'jquery';
import utils from "services/utils";

const GET_EXCHANGE_RATES = 'getExchangeRates';
const AJAX_UPDATE_STATUS = 'ajaxUpdateStatus';
const GET_BALANCE_AND_SUM = 'getBalanceAndSum';
const GET_CURRENCIES = 'getCurrencies';
const GET_EXCHANGE_RATES_FOR_HEADER = 'getExchangeRatesForHeader';
const EXCHANGE_RATES_FOR_HEADER = 'exchangeRatesForHeader';
const GET_ADDITION_DOC_PHOTO_LOADED_STATUS = 'getAdditionDocPhotoLoadedStatus';
const GET_PAYMENT_SYSTEMS = 'getPaymentsSystems';
const FULL_EXCHANGE_RATES = 'getFullExchangeRates';
const GET_CASH_METHODS_SETTINGS = 'getCashMethodsSettings';
const GET_BONUSES_BALANCE = 'getBonusesBalance';
const GET_COUNT_ACTIVE_ORDERS = 'getCountActiveOrders';

let inst = null;
let availableTasks = [
    GET_EXCHANGE_RATES,
    AJAX_UPDATE_STATUS,
    GET_BALANCE_AND_SUM,
    GET_CURRENCIES,
    GET_EXCHANGE_RATES_FOR_HEADER,
    GET_PAYMENT_SYSTEMS,
    FULL_EXCHANGE_RATES,
    EXCHANGE_RATES_FOR_HEADER,
    GET_ADDITION_DOC_PHOTO_LOADED_STATUS,
    GET_CASH_METHODS_SETTINGS,
    GET_BONUSES_BALANCE,
    GET_COUNT_ACTIVE_ORDERS
];

class CommonUpdater {
    constructor() {
        if (!inst) {
            inst = this;
            inst.tasks = {};
            inst.eventNamespace = 'app.';
            this.bodyEl = $('body');
        }
        return inst;
    }

    addTask(obj) {
        obj = $.extend(true, this.constructor.getDefaultTask(), obj);
        if (obj.name !== '' && !this.tasks[obj.name] && $.inArray(obj.name, availableTasks) !== -1) {
            this.tasks[obj.name] = obj;
            if (typeof obj.sendData === 'function') {
                this.tasks[obj.name].sendData = obj.sendData();
            }
        }
    }

    updateTask(taskNames) {
        let sendData = this.buildSendData(taskNames);
        return this.sendRequest(sendData);
    }

    updateAllTasks() {
        let sendData = this.buildSendData();
        return this.sendRequest(sendData);
    }

    buildSendData(taskNames = null) {
        var sendData = {};
        for (var taskName in this.tasks) {
            if (this.tasks.hasOwnProperty(taskName)) {
                if (Array.isArray(taskNames)) {
                    if ($.inArray(taskName, taskNames) === -1) {
                        continue;
                    }
                }
                let data = this.tasks[taskName].sendData;
                if (typeof data === 'function') {
                    data = data();
                }
                sendData[taskName] = {data: data};
            }
        }
        return sendData;
    }

    sendRequest(sendData) {
        var that = this;
        var promises = [];

        const addResolvedResult = () => {
            let aDeferred = $.Deferred();
            aDeferred.resolve({});
            promises.push(aDeferred);
        };

        promises.push($.post(utils.getLocalizeUrl('/api/front/common-updater'), sendData)); // index 0

        if (sendData[CommonUpdater.prototype.GET_PAYMENT_SYSTEMS]) { // index 0
            // let aDeferred = $.Deferred();
            // aDeferred.resolve(getPaymentsSystemsResponse);
            // promises.push(aDeferred);
            promises.push($.get(utils.getLocalizeUrl('/api/front/get-payments-systems-for-calculator'))); // todo: Uncomment when it ready to work for unauth users.
        } else {
            addResolvedResult();
        }

        if (sendData[CommonUpdater.prototype.FULL_EXCHANGE_RATES]) { // index 1
            promises.push($.post(utils.getLocalizeUrl('/api/front/exchange-rates'), {
                cashMethodId: 2,
                showHistory: 1
            }));/*
            let aDeferred = $.Deferred();
            let formData = new FormData();
            formData.set('cashMethodId', 2);
            formData.set('showHistory', 1);
            $.ajax({
                url: utils.getLocalizeUrl('/api/front/exchange-rates'),
                data: formData,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function(data){
                    aDeferred.resolve(data);
                    // alert(data);
                }
            });
            promises.push(aDeferred);
            */
            // promises.push($.post(utils.getLocalizeUrl('/api/front/exchange-rates'), formData));
        } else {
            addResolvedResult();
        }

        if (sendData[CommonUpdater.prototype.EXCHANGE_RATES_FOR_HEADER]) { // index 2
            promises.push($.post(utils.getLocalizeUrl('/api/front/exchange-rates-for-header'), {
                cashMethodId: 2,
                showHistory: 1
            }));
        } else {
            addResolvedResult();
        }

        if (sendData[CommonUpdater.prototype.GET_CASH_METHODS_SETTINGS]) { // index 3
            promises.push($.get(utils.getLocalizeUrl('/api/front/get-cash-methods-settings')));
        } else {
            addResolvedResult();
        }

        return $.when(...promises)
            .then((resp, ...resps) => {
                const getCommonUpdaterResult = () => {
                    resp = resp[0];
                    if (resp.OK) {
                        for (var taskName in resp.tasks) {
                            var taskEvent = $.Event(that.eventNamespace + taskName);
                            taskEvent._appData = resp.tasks[taskName].data;
                            that.bodyEl.trigger(taskEvent);

                            if (that.tasks[taskName].oneSend) {
                                delete (that.tasks[taskName]);
                            }
                        }
                        return resp.tasks;
                    }
                    return {};
                };
                let result = getCommonUpdaterResult();
                if (resps.length) {
                    result = resps.reduce((result, response, index) => {
                        if (index === 0 && response[0] && response[0].type === 'success') {
                            result[CommonUpdater.prototype.GET_PAYMENT_SYSTEMS] = response[0];
                        }
                        if (index === 1 && response && response[0] && response[0].type === 'success') {
                            result[CommonUpdater.prototype.FULL_EXCHANGE_RATES] = response[0];
                        }
                        if (index === 2 && response && response[0] && response[0].type === 'success') {
                            result[CommonUpdater.prototype.EXCHANGE_RATES_FOR_HEADER] = response[0];
                        }
                        if (index === 3 && response && response[0] && response[0].type === 'success') {
                            result[CommonUpdater.prototype.GET_CASH_METHODS_SETTINGS] = response[0];
                        }
                        return result;
                    }, result);
                }
                return result;
            });
    }

    addTaskListener(taskName, callBack) {
        if (this.tasks[taskName] && typeof callBack === 'function') {
            this.bodyEl.on(this.eventNamespace + taskName, callBack);
        }
    }

    removeTaskListener(taskName, callBack) {
        if (this.tasks[taskName] && typeof callBack === 'function') {
            this.bodyEl.off(this.eventNamespace + taskName, callBack);
        }
    }

    static getDefaultTask() {
        return {
            name: '',
            oneSend: false,
            sendData: {
                send: 1
            }
        };
    }
}

CommonUpdater.prototype.GET_EXCHANGE_RATES = GET_EXCHANGE_RATES;
CommonUpdater.prototype.AJAX_UPDATE_STATUS = AJAX_UPDATE_STATUS;
CommonUpdater.prototype.GET_BALANCE_AND_SUM = GET_BALANCE_AND_SUM;
CommonUpdater.prototype.GET_PAYMENT_SYSTEMS = GET_PAYMENT_SYSTEMS;
CommonUpdater.prototype.GET_CURRENCIES = GET_CURRENCIES;
CommonUpdater.prototype.GET_EXCHANGE_RATES_FOR_HEADER = GET_EXCHANGE_RATES_FOR_HEADER;
CommonUpdater.prototype.EXCHANGE_RATES_FOR_HEADER = EXCHANGE_RATES_FOR_HEADER;
CommonUpdater.prototype.GET_ADDITION_DOC_PHOTO_LOADED_STATUS = GET_ADDITION_DOC_PHOTO_LOADED_STATUS;
CommonUpdater.prototype.FULL_EXCHANGE_RATES = FULL_EXCHANGE_RATES;
CommonUpdater.prototype.GET_CASH_METHODS_SETTINGS = GET_CASH_METHODS_SETTINGS;
CommonUpdater.prototype.GET_BONUSES_BALANCE = GET_BONUSES_BALANCE;
CommonUpdater.prototype.GET_COUNT_ACTIVE_ORDERS = GET_COUNT_ACTIVE_ORDERS;

export default new CommonUpdater();